import { ATTRS, TAGS } from '../constants';
import { EntitiesManager } from '../entitiesManager';
import { Entity, ISOFileInformation } from '../types';
import { AllocationStampEntity } from './AllocationStamp';
import { DeviceEntity } from './Device';

export class DeviceAllocationEntity implements Entity {
  public static fromXML(
    xml: any,
    matchIDs: any,
    files: ISOFileInformation[],
    entitiesManager: EntitiesManager
  ) {
    const attrs = xml._attributes;
    const device = entitiesManager.getEntityByIsoId<DeviceEntity>(
      attrs[ATTRS.DeviceAllocation.DeviceIdRef]
    );
    const allocationStamp = (xml[TAGS.AllocationStamp] || []).map((xml) =>
      AllocationStampEntity.fromXML(xml, matchIDs, files, entitiesManager)
    )[0];

    return {
      entity: new DeviceAllocationEntity(
        attrs[ATTRS.DeviceAllocation.ClientNAMEValue],
        attrs[ATTRS.DeviceAllocation.ClientNAMEMask],
        device,
        allocationStamp
      ),
    };
  }
  public type = TAGS.DeviceAllocation;
  public id: string;

  constructor(
    public clientNAMEValue: string,
    public clientNAMEMask?: string,
    public device?: DeviceEntity,
    public allocationStamp?: AllocationStampEntity
  ) {
    this.id = this.clientNAMEValue;
  }

  public toXML(xmlId: string, entitiesManager: EntitiesManager) {
    const deviceIsoId = entitiesManager.registerEntity(this.device);
    return {
      _attributes: {
        [ATTRS.DeviceAllocation.ClientNAMEValue]: this.clientNAMEValue,
        ...(this.clientNAMEMask && {
          [ATTRS.DeviceAllocation.ClientNAMEMask]: this.clientNAMEMask,
        }),
        ...(deviceIsoId && { [ATTRS.DeviceAllocation.DeviceIdRef]: deviceIsoId }),
      },
      [TAGS.AllocationStamp]: this.allocationStamp
        ? [this.allocationStamp.toXML(null, entitiesManager)]
        : [],
    };
  }
}
